export default __webpack_public_path__ + "static/220803_天下布魔更新內容預告_chs-f72f25b09d5a255e28443bd727ee846d.webp";